module.exports = __webpack_public_path__ + "static/img/txLeft.c1a89e1e.png";